import axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import { applyAuthorizationHeader, clearAccessToken, clearStoredUser, getAccessToken } from './utils/auth';

window._ = require('lodash');
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.baseURL = '/api';
applyAuthorizationHeader(getAccessToken());

window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error && error.response && error.response.status === 401) {
        console.log('Unauthorized, logging out...');
        clearAccessToken();
        clearStoredUser();
        applyAuthorizationHeader('');

        if (window.location.hash !== '#/login' && window.location.hash !== '#/login/') {
            window.location.href = '/#/login';
        }
    }

    return Promise.reject(error);
});

export default ElementUI;



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js